<template>
  <TxRendererScreenshotArea>
    <StudentPosterLoader>
      <StudentPoster/>
      <StudentPosterTitle/>
    </StudentPosterLoader>
  </TxRendererScreenshotArea>
</template>

<script>
import StudentPoster from './StudentPoster'
import StudentPosterTitle from './StudentPosterTitle'
import StudentPosterModule from "../store-mixin";

export default {
  name: 'StudentPosterProduct',
  mixins: [StudentPosterModule()],
  components: {
    StudentPoster,
    StudentPosterTitle,
  },
}
</script>

<style lang="scss">

//Dont forget to add or change fonts in shopkeeper-child/include/textArtProducts/assets/fonts
//
/**
//design 1
//Grattis: Darleston
//Name and number: FogtwoNo5
//
//design 2
//Name and number: Aku & Kamu
//Grattis till studenten: Ants Valley Personal Use

//design 3
//Grattis till studenten: FogtwoNo5

//design 4
//Grattis: Ants Valley Personal Use
//Name and number: Aku & Kamu

//design 5
//Name and number: Ants Valley Personal Use
//Student: Cinzel

design 6 ???
Grattis till studenten: Eufoniem
Name and number: Futura BdCn BT

design 7 ???
Name and number: Futura BdCn BT
Studenten 2023: Eufoniem

//design 8
//Grattis: CIAO CIAO SOLID Alt
//Name and number: Aku & Kamu

//design 9
//Name: Aku & Kamu
//Number: Eufoniem
//Grattis till studenten: Eufoniem


design 10 ???
Grattis: Eufoniem
Name and number: Futura BdCn BT

design 11 ???
Name and number: Futura BdCn BT
Studenten 2023: Eufoniem

design 12 ???
Grattis: Eufoniem
Name and number: Futura BdCn BT
 */

@font-face {
  font-family: 'Sofia Pro';
  src: url('../assets/fonts/SofiaPro-Bold.woff2') format('woff2'),
  url('../assets/fonts/SofiaPro-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Just Lovely';
  src: url('../assets/fonts/JustLovely.woff2') format('woff2'),
  url('../assets/fonts/JustLovely.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Cinzel';
  src: url('../assets/fonts/Cinzel-Regular.woff2') format('woff2'),
  url('../assets/fonts/Cinzel-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Eufoniem One';
  src: url('../assets/fonts/EufoniemOne.woff2') format('woff2'),
  url('../assets/fonts/EufoniemOne.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Darleston';
  src: url('../assets/fonts/Darleston.woff2') format('woff2'),
  url('../assets/fonts/Darleston.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'FogtwoNo5';
  src: url('../assets/fonts/FogtwoNo5.woff2') format('woff2'),
  url('../assets/fonts/FogtwoNo5.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CIAO CIAO SOLID Alt';
  src: url('../assets/fonts/CIAOCIAOSOLID-Alt.woff2') format('woff2'),
  url('../assets/fonts/CIAOCIAOSOLID-Alt.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Ants Valley Personal Use';
  src: url('../assets/fonts/AntsValley-PersonalUse.woff2') format('woff2'),
  url('../assets/fonts/AntsValley-PersonalUse.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Bernhard BdCn BT';
  src: url('../assets/fonts/BernhardBoldCondensedBT-Regular.woff2') format('woff2'),
  url('../assets/fonts/BernhardBoldCondensedBT-Regular.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Aku and Kamu';
  src: url('../assets/fonts/AkuKamu.woff2') format('woff2'),
  url('../assets/fonts/AkuKamu.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Futura BdCn BT';
  src: url('../assets/fonts/futura_bold_font_2-webfont.woff2') format('woff2'),
  url('../assets/fonts/futura_bold_font_2-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

</style>

<style scoped lang="scss">

</style>

